function initialStatsFromGroupAndBalance(playersInGroup, balanceState) {
  return Object.fromEntries(playersInGroup.map(player => [player.id, {
    name: player.displayName,
    email: player.email,
    win: 0,
    loss: 0,
    firstGame: null,
    lastGame: null,
    balance: balanceState[player.id]?.amount || 0,
    deposited: balanceState[player.id]?.deposited || 0,
    spent: balanceState[player.id]?.spent || 0,
    pricePerWin: null
  }]));
}

const generateStatistics = (playersInGroup, gamesInGroup, balanceState, gamesState) => {
  const groupGameIds = Object.fromEntries(gamesInGroup.map(g => [g.id, g]));
  const stats = initialStatsFromGroupAndBalance(playersInGroup, balanceState);
  Object.keys(gamesState)
    .forEach(game => {
      if (groupGameIds[game]) {
        const winners = gamesState[game].winnerList;
        const loosers = gamesState[game].ticketsLost;
        if (winners) {
          winners.forEach(winner => {
            if (stats[winner.playerId]) {
              stats[winner.playerId].win += 1;
            }
          });
        }
        if (loosers) {
          loosers.forEach(looser => {
            if (stats[looser]) {
              stats[looser].loss += 1;
            }
          });
        }

        const { startTime } = groupGameIds[game];
        const playersInGame = groupGameIds[game].tickets
          ? Object.keys(groupGameIds[game].tickets)
          : [];

        if (startTime) {
          playersInGame.filter(player => playersInGroup.map(p => p.id).includes(player))
            .forEach(playerId => {
              const statsForPlayer = stats[playerId];
              if (!statsForPlayer.firstGame || statsForPlayer.firstGame > startTime) {
                stats[playerId].firstGame = startTime;
              }
              if (!statsForPlayer.lastGame || statsForPlayer.lastGame < startTime) {
                stats[playerId].lastGame = startTime;
              }
            });
        }
      }
    });
  playersInGroup.map(p => p.id)
    .forEach(playerId => {
      if (stats[playerId].win > 0 && stats[playerId].spent > 0) {
        stats[playerId].pricePerWin = parseInt(stats[playerId].spent / stats[playerId].win, 0);
      }
    });
  return Object.values(stats);
};

export default generateStatistics;
